// extracted by mini-css-extract-plugin
export var originalPrice = "_wk-0";